import axios from 'axios';
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:3333/api/v1',
  withCredentials: true,
  timeout: 15_000,
});
let accessToken: string | null = null;
export const setAccessToken = (token: string | null) => {
  accessToken = token;
};
api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

let refreshPromise: Promise<string> | null = null;
api.interceptors.response.use(
  (response) => response,
  async (error: unknown) => {
    if (!axios.isAxiosError(error))
      return Promise.reject(error instanceof Error ? error : new Error('Falha inesperada na API.'));
    const request = error.config as (typeof error.config & { _retried?: boolean }) | undefined;
    const isAuthRoute = request?.url?.includes('/auth/') ?? false;
    if (error.response?.status !== 401 || !request || request._retried || isAuthRoute)
      return Promise.reject(error);
    request._retried = true;
    refreshPromise ??= api
      .post<{ accessToken: string }>('/auth/session')
      .then(({ data }) => {
        setAccessToken(data.accessToken);
        return data.accessToken;
      })
      .finally(() => {
        refreshPromise = null;
      });
    const token = await refreshPromise;
    request.headers.Authorization = `Bearer ${token}`;
    return api.request(request);
  },
);
export function apiErrorMessage(error: unknown): string {
  if (axios.isAxiosError<unknown>(error)) {
    const data = error.response?.data;
    if (typeof data === 'object' && data !== null && 'error' in data) {
      const bodyError = (data as { error?: unknown }).error;
      if (
        typeof bodyError === 'object' &&
        bodyError !== null &&
        'message' in bodyError &&
        typeof (bodyError as { message?: unknown }).message === 'string'
      ) {
        const message = (bodyError as { message: string }).message;
        const requestId =
          'requestId' in bodyError && typeof bodyError.requestId === 'string'
            ? bodyError.requestId
            : undefined;
        return requestId ? `${message} Código de suporte: ${requestId}.` : message;
      }
    }
    return 'Não foi possível falar com o servidor.';
  }
  return 'Ocorreu um erro inesperado.';
}
